import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { canAccess } from "../../utils/permissions";

export default function CreateButton() {
  if (!canAccess("create_quote") && !canAccess("create_job")) {
    return null;
  }

  return (
    <Link to="/profile/create/quote-job">
      <button
        className="flex items-center gap-3 px-6 py-2 rounded-[4px] font-semibold
                   transition-all duration-300 transform bg-[#1665f6] text-white
                   hover:bg-[#145ed7] hover:shadow-md hover:scale-105"
      >
        <div className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-100">
          <X className="w-2 h-2 text-gray-600" />
        </div>
        <span className="text-sm">Create</span>
      </button>
    </Link>
  );
}
